import {createContext, useContext} from 'react';

export const IsMobileContext = createContext(window.innerWidth <= 880)
export const IsSmallDesktopContext = createContext(window.innerWidth <= 1200 && window.innerWidth > 880)

export const useIsMobileContext = () => {
    const isMobile = useContext(IsMobileContext)
    const isSmallDesktop = useContext(IsSmallDesktopContext)
    return { isMobile, isSmallDesktop }
}